import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-frm-forms-create-result-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe]
})
export class FrmFormsCreateResultApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Create Form Result",
            description:
                "This endpoint can be used to create a new result for a form. This endpoint does not support submitting multiple fields with the same name within a single form.",
            httpMethod: "POST",
            path: "/formsdata/{id}/results",

            parameters: [
                {
                    name: "id",
                    description: "ID of the Form the Result should be created for.",
                    in: "path",
                    paramType: "integer",
                    required: true,
                    example: "12",
                },
                {
                    name: '"Field Name"',
                    description:
                        "The field to be filled in the result. All fields to be filled should be included in the request body and match the names exactly.",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: {
                        "Form Field Text": "Value A",
                        "Form Field Number A": 123,
                        "Form Field Number B": "123",
                        "Form Field Date A": "2025-12-31",
                        "Form Field Date Time A": "2025-12-31T14:12:00+1",
                    },
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
